export class CommonConstant {
  public static readonly INIT_TOTAL_ITEM = 0;
  public static readonly INIT_TABLE_LOADING = false;
  public static readonly MIN_PAGE_INDEX = 0;
  public static readonly MIN_PAGE_SIZE = 20;
  public static readonly MAX_PAGE_SIZE = 2147483647;
}
